import { Injectable } from '@angular/core'
import { Action, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

import { SelectedItemState } from './selected-item.reducer'
import * as SelectedItemSelectors from './selected-item.selectors'
import { BehaviorSubject, filter, map, switchMap } from 'rxjs'
import { ItemFacade } from 'libs/gb-front/item/data-access/src/lib/+state/items.facade'

@Injectable({
  providedIn: 'root',
})
export class SelectedItemFacade implements GbBaseFacade {
  loaded$ = this.store.select(SelectedItemSelectors.getSelectedItemLoaded)
  selectedItem$ = this.store.select(SelectedItemSelectors.getSelectedItem)
  selectedItemId$ = this.store.select(SelectedItemSelectors.getSelectedItemId)
  selectedItemName$ = this.store.select(SelectedItemSelectors.getSelectedItemName)
  selectedBiddingItem$ = this.store.select(SelectedItemSelectors.getSelectedBiddingItem)
  selectedDonationItem$ = this.store.select(SelectedItemSelectors.getSelectedDonationItem)
  selectedPurchaseItem$ = this.store.select(SelectedItemSelectors.getSelectedPurchaseItem)
  selectedRaffleItem$ = this.store.select(SelectedItemSelectors.getSelectedRaffleItem)
  selectedItemImages$ = this.store.select(SelectedItemSelectors.getSelectedItemImages)
  selectedItemTnC$ = this.store.select(SelectedItemSelectors.getSelectedItemTnC)
  currentAmount$ = this.store.select(SelectedItemSelectors.getCurrentAmount)

  // checks if full selected item previously loaded in items state
  previouslyLoaded$ = this.selectedItem$.pipe(
    filter((selectedItem) => !!selectedItem),
    switchMap((selectedItem) =>
      this.itemFacade.selectItemById$(selectedItem!.uuid, true).pipe(map((item) => !!item && 'description' in item)),
    ),
  )

  changeItemBehaviorSubject$ = new BehaviorSubject(true)

  nextItemId$ = (isFiltersApplied = false, categoryId?: string) => {
    if (!isFiltersApplied && !categoryId) return this.store.select(SelectedItemSelectors.getNextItemId)
    return this.store.select(
      categoryId
        ? SelectedItemSelectors.getNextCategoryItemId(categoryId)
        : SelectedItemSelectors.getNextFilteredItemId,
    )
  }
  previousItemId$ = (isFiltersApplied = false, categoryId?: string) => {
    if (!isFiltersApplied && !categoryId) return this.store.select(SelectedItemSelectors.getPreviousItemId)
    return this.store.select(
      categoryId
        ? SelectedItemSelectors.getPreviousCategoryItemId(categoryId)
        : SelectedItemSelectors.getPreviousFilteredItemId,
    )
  }

  constructor(private store: Store<SelectedItemState>, private itemFacade: ItemFacade) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }

  onItemChange(): void {
    this.changeItemBehaviorSubject$.next(false)
    setTimeout(() => this.changeItemBehaviorSubject$.next(true))
  }
}
